
export interface ApiError {
    kind: "ApiError";
    statusCode: number;
    message: string;
}

export interface ApiValidationError {
    kind: "ApiValidationError";
    message: Record<string, string[]>;
}

export interface UnexpectedError {
    kind: "UnexpectedError";
    message: Error;
}

export interface Unauthorized {
    kind: "Unauthorized";
    message: Error;
}

export interface NotFound {
    kind: "NotFound";
    message: Error;
}

export enum DataErrorKind {
    ApiError = "ApiError",
    UnexpectedError = "UnexpectedError",
    Unauthorized = "Unauthorized",
    NotFound = "NotFound",
    ApiValidationError = "ApiValidationError",
}

export interface ErrorState {
    error?: DataError;
}

export function isApiError(error: DataError): error is ApiError {
    return error?.kind === DataErrorKind.ApiError;
}

export function isUnexpectedError(error: DataError): error is UnexpectedError {
    return error?.kind === DataErrorKind.UnexpectedError;
}

export function isUnauthorized(error: DataError): error is Unauthorized {
    return error?.kind === DataErrorKind.Unauthorized;
}

export function isNotFound(error: DataError): error is NotFound {
    return error?.kind === DataErrorKind.NotFound;
}


export function isApiValidationError(error: DataError): error is ApiValidationError {
    return error?.kind === DataErrorKind.ApiValidationError;
}

export type DataError = ApiError | ApiValidationError | UnexpectedError | Unauthorized | NotFound;
